export const liststeps = () =>  [
  
  {
    target: '[data-tour="list-filters"]',
    title: 'Filters',
    content:
      'Filter work items by type, status and assignee.',
      disableBeacon: true,
  },
  {
    target: '[data-tour="list-table"]',
    title: 'Work Item List',
    content:
      'View all work items with their type, status, assignee, sprint and due date.',
      disableBeacon: true,
  },
];